import { authSlice } from '@wellesley/auth'
import { useDispatch, useSelector } from 'react-redux'
import {
  userSlice,
  useCurrentUserUpdate,
  useGetApiV1AccountsProfileQuery,
} from '@wellesley/user'

const useUpdateMyProfile = () => {
  const dispatch = useDispatch()
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)

  useGetApiV1AccountsProfileQuery(
    {
      htmlContent: false,
    },
    {
      skip: !isLogged,
    },
  )
  useCurrentUserUpdate({
    onUpdate: (user) => dispatch(userSlice.actions.updateUser(user)),
  })
}

export default useUpdateMyProfile
